import {
  Box,
  Heading,
  Text
} from "@chakra-ui/react";
import Lang from "../../Lang";

export default function SectionHeading({ title, subtitle }) {
  return (
    <>
      <Box className="opacityUp">
        <Heading
          pt={{ base: 20, md: 30, xl: 40 }}
          as="h2"
          color={"#4aeade"}
          align={"center"}
          fontSize={{ base: "3em", md: "4em", lg: "5em", xl: "6em" }}
          className="barlow-black"
        >
          <Lang text={title} />
        </Heading>
      </Box>
      <Text
        align={"center"}
        fontSize={{ base: "1.5em", md: "1.6em", lg: "1.8em", xl: "2em" }}
        className="barlow-regular"
        mb={{ base: 10, md: 20, xl: 20 }}
        px={{base:5}}
      >
        <Lang text={subtitle} />
        </Text>
    </>
  );
}